import {type ICarrierAdminAuthorizationConfig} from 'shared/Header/components/data'

export interface ICarrierAdminUAPageAccessRights {
    OfferMenu: string
    ManageUASpotRATEOffers: string
    ViewUASPOTofferqueue: string
    Marketplace: string
    Booking: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    UpdateAirWaybillStatus: string
    Efreight: string
    CreateRetrieveMAWB: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    eClaims: string
    FileDamageReport: string
    ViewDamageReportStatus: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
}

const CarrierAdminUA = () => {
    const carrierAdminUAConfigKey1: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminUAValue1: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // Create more CarrierAdminAuthorizationConfig instances for other configurations

    const carrierAdminUAConfigKey2: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminUAValue2: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey3: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminUAValue3: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey4: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminUAValue4: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey5: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminUAValue5: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey6: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminUAValue6: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey7: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminUAValue7: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey8: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminUAValue8: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // AministratorStatus denied

    const carrierAdminUAConfigKey9: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminUAValue9: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey10: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminUAValue10: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey11: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminUAValue11: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey12: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminUAValue12: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey13: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminUAValue13: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey14: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminUAValue14: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey15: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminUAValue15: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey16: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminUAValue16: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'Y',
        ViewUASPOTofferqueue: 'Y',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // GSA Status Denied

    const carrierAdminUAConfigKey17: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminUAValue17: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminUAConfigKey18: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminUAValue18: ICarrierAdminUAPageAccessRights = {
        OfferMenu: 'Y',
        ManageUASpotRATEOffers: 'N',
        ViewUASPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const adminHashMap = new Map<ICarrierAdminAuthorizationConfig, ICarrierAdminUAPageAccessRights>()
    adminHashMap.set(carrierAdminUAConfigKey1, carrierAdminUAValue1)
    adminHashMap.set(carrierAdminUAConfigKey2, carrierAdminUAValue2)
    adminHashMap.set(carrierAdminUAConfigKey3, carrierAdminUAValue3)
    adminHashMap.set(carrierAdminUAConfigKey4, carrierAdminUAValue4)
    adminHashMap.set(carrierAdminUAConfigKey5, carrierAdminUAValue5)
    adminHashMap.set(carrierAdminUAConfigKey6, carrierAdminUAValue6)
    adminHashMap.set(carrierAdminUAConfigKey7, carrierAdminUAValue7)
    adminHashMap.set(carrierAdminUAConfigKey8, carrierAdminUAValue8)
    adminHashMap.set(carrierAdminUAConfigKey9, carrierAdminUAValue9)
    adminHashMap.set(carrierAdminUAConfigKey10, carrierAdminUAValue10)
    adminHashMap.set(carrierAdminUAConfigKey11, carrierAdminUAValue11)
    adminHashMap.set(carrierAdminUAConfigKey12, carrierAdminUAValue12)
    adminHashMap.set(carrierAdminUAConfigKey13, carrierAdminUAValue13)
    adminHashMap.set(carrierAdminUAConfigKey14, carrierAdminUAValue14)
    adminHashMap.set(carrierAdminUAConfigKey15, carrierAdminUAValue15)
    adminHashMap.set(carrierAdminUAConfigKey16, carrierAdminUAValue16)
    adminHashMap.set(carrierAdminUAConfigKey17, carrierAdminUAValue17)
    adminHashMap.set(carrierAdminUAConfigKey18, carrierAdminUAValue18)

    return adminHashMap
}
export default CarrierAdminUA
